export const anchorController = () => {
    const container = document.querySelector('.anchor__container');
    const originalWidth = container.scrollWidth;
    const originalHeight = container.scrollHeight;
    const anchorButton = document.querySelector('.anchor__container-btn');
    const toggleAnchor = () => {
        if (container.classList.contains('active')) {
            container.style.maxHeight = '80px';
            container.style.maxWidth = '80px';
            container.classList.remove('active');
        }
        else {
            container.style.maxHeight = 'auto';
            container.style.maxWidth = 'auto';
            container.style.maxHeight = `${originalHeight + 50}px`;
            container.style.maxWidth = `${originalWidth + 50}px`;
            container.classList.add('active');
        }
    };
    anchorButton.addEventListener('click', () => {
        toggleAnchor();
    });
};
import { isSmallScreen } from './utils';
export const tagReplacer = () => {
    function debounce(func, delay) {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }
    function replaceHTagWithP() {
        if (isSmallScreen()) {
            const elementTags = document.querySelectorAll('.dynamic-element-tag-h3');
            elementTags.forEach((el) => {
                if (el.tagName.toLowerCase() === 'p') {
                    const hTagElement = document.createElement('h3');
                    hTagElement.textContent = el.textContent;
                    for (let i = 0; i < el.attributes.length; i++) {
                        const attr = el.attributes[i];
                        hTagElement.setAttribute(attr.name, attr.value);
                    }
                    el.parentNode.replaceChild(hTagElement, el);
                }
                if (el.tagName.toLowerCase() === 'h3') {
                    const pTagElement = document.createElement('p');
                    pTagElement.textContent = el.textContent;
                    for (let i = 0; i < el.attributes.length; i++) {
                        const attr = el.attributes[i];
                        pTagElement.setAttribute(attr.name, attr.value);
                    }
                    el.parentNode.replaceChild(pTagElement, el);
                }
            });
        }
    }
    const debouncedReplaceH2WithP = debounce(replaceHTagWithP, 250);
    replaceHTagWithP();
    window.addEventListener('resize', debouncedReplaceH2WithP);
};
export const travelBlog = () => {
    tagReplacer();
    let bottomBlogsTotalNumberOfPages = 0;
    let bottomBlogsCurrentPage = 2;
    let topBlogsTotalNumberOfPages = 0;
    let topBlogsCurrentPage = 2;
    let animationDelay = 0;
    const delayIncrement = 0.2;
    const paginationContainer = document.querySelector('.travel-blog-paging');
    const bottomMoreBtn = paginationContainer.querySelector('.travel-blog__more-btn');
    const topMoreBtn = document.querySelector('.travel-blog__top-more-btn');
    const TOP_FLAG = 'TOP';
    const topBlogContainer = document.getElementById('blogs__top');
    const bottomBlogContainer = document.getElementById('travel-blog__container');
    const topFetchParams = {
        currentPage: topBlogsCurrentPage,
        totalNumberOfPages: topBlogsTotalNumberOfPages,
        isTop: true,
    };
    const bottomFetchParams = {
        currentPage: bottomBlogsCurrentPage,
        totalNumberOfPages: bottomBlogsTotalNumberOfPages,
        isTop: false,
    };
    topMoreBtn.addEventListener('click', () => {
        if (!topMoreBtn.disabled) {
            topMoreBtn.disabled = true; // Disable button
            fetchAndRenderBlogData(topFetchParams, topMoreBtn);
        }
    });
    bottomMoreBtn.addEventListener('click', () => {
        if (!bottomMoreBtn.disabled) {
            bottomMoreBtn.disabled = true; // Disable button
            fetchAndRenderBlogData(bottomFetchParams, bottomMoreBtn);
        }
    });
    function renderBlogItems(blogModel) {
        animationDelay = 0;
        const newElementsContainer = document.createElement('div');
        blogModel.data.forEach((blog) => {
            const blogCard = document.createElement('a');
            blogCard.setAttribute('href', blog === null || blog === void 0 ? void 0 : blog.blogUrl);
            blogCard.className = `blog-card__container  blog-card__container--animated ${blogModel.classes} cursor-pointer`;
            blogCard.style.animationDelay = `${animationDelay}s`;
            animationDelay += delayIncrement;
            if (blogModel.isTop) {
                blogCard.innerHTML = `<div 
                  class="">
                  <figure class="rounded-t-xl">
                     <img src="${blog === null || blog === void 0 ? void 0 : blog.imageUrl}" alt="${blog === null || blog === void 0 ? void 0 : blog.title}"
                        class="w-full object-cover max-h-[230px] h-[230px] rounded-t-xl lg:rounded-xl" />
                  </figure>
                  <div class=" flex flex-col justify-between px-1 pt-3">
                     <div class="border-b my-2 pb-5">
                        <h2 class="text-xl font-semibold text-[#183B56] mb-3 line-clamp-1">
                           ${blog === null || blog === void 0 ? void 0 : blog.title}
                        </h2>
                        <div class="flex flex-col justify-between">
                          <p class="text-lg text-[#183B56] line-clamp-3 min-h-[84px]">
                            ${blog === null || blog === void 0 ? void 0 : blog.description}
                          </p>  
                      </div>
                     </div>
                      
                     <div class="flex items-center my-2 justify-between ">
                        <div class="flex">
                           <p class=" text-base sm:text-sm md:text-base text-[#183B56] font-bold">
                              <span
                                 class="text-sm md:text-base xl:text-base font-medium text-[#183B56] italic">di</span>&nbsp;
                               ${blog === null || blog === void 0 ? void 0 : blog.blogAuthor}
                           </p>
                        </div>
                        <div class="w-1/2 flex justify-end items-center flex-1">
                           <span class="text-base font-semibold text-[#183B56]">
                              ${blog === null || blog === void 0 ? void 0 : blog.blogDate}
                           </span>
                        </div>
                     </div>
                  </div>
               </div>`;
            }
            else {
                blogCard.innerHTML = `
    <div class="bg-white t-cut-button__magic-animation cursor-pointer grid grid-cols-1 md:grid-cols-3 shadow-sm rounded-xl md:rounded-xl overflow-hidden w-full">
      <figure class="w-full p-3">
        <img src="${blog === null || blog === void 0 ? void 0 : blog.imageUrl}" alt="${blog === null || blog === void 0 ? void 0 : blog.title}" class="w-full max-h-[230px] md:h-full rounded-t-xl md:rounded-xl object-cover" />
      </figure>
      <div class="p-3 md:pr-6 pb-4 flex flex-col justify-between col-span-2">
        <h3 class="text-xl font-semibold text-[#183B56] mb-2 line-clamp-1">
          ${blog === null || blog === void 0 ? void 0 : blog.title}
        </h3>
        <p class="text-lg text-[#183B56] mb-4 line-clamp-2">
          ${blog === null || blog === void 0 ? void 0 : blog.description}
        </p>
        <div class="flex items-center justify-between border-t pt-3">
          <p class="text-sm md:text-base text-[#183B56] font-bold">
          <span class="font-medium italic">di</span> ${blog === null || blog === void 0 ? void 0 : blog.blogAuthor}
          </p>
          <span class="text-sm md:text-base font-bold text-[#183B56]">
            ${blog === null || blog === void 0 ? void 0 : blog.blogDate}
          </span>
        </div>
      </div>
    </div>
  `;
            }
            newElementsContainer.appendChild(blogCard);
        });
        while (newElementsContainer.firstChild) {
            blogModel.container.appendChild(newElementsContainer.firstChild);
        }
    }
    function fetchAndRenderBlogData(params, button) {
        fetch(`/umbraco/api/travelblog/GetBlogPages?page=${params.currentPage}${params.isTop ? `&filter=${TOP_FLAG}` : ''}`)
            .then((response) => {
            params.currentPage += 1;
            params.totalNumberOfPages = parseInt(response.headers.get('Totalnumberofpages') || '0', 10);
            return response.json();
        })
            .then((data) => {
            let blogModel;
            if (params.isTop) {
                blogModel = {
                    data: data,
                    container: topBlogContainer,
                    classes: 'bg-white shadow-sm rounded-xl md:rounded-xl w-full p-3 t-cut-button__magic-animation hover:text-primary-color',
                    isTop: true,
                };
            }
            else {
                blogModel = {
                    data: data,
                    container: bottomBlogContainer,
                    classes: '',
                    isTop: false,
                };
            }
            renderBlogItems(blogModel);
            button.disabled = false; // Re-enable button
            if (params.currentPage > params.totalNumberOfPages) {
                button.style.display = 'none';
            }
        })
            .catch((error) => {
            console.error('Error fetching data:', error);
            button.disabled = false; // Re-enable button on error
        });
    }
};
